import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_nvmdrnpzby: FaireCollectionEntity = {
  token: "pbc_nvmdrnpzby",
  type: "collection",
  name: "Baby Headbands & Hats",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7a675a4beb91f8376c494834297c70fbad6d87c15f285cfe02f7355296974648.jpeg",
  itemCount: 25,
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:22.137Z",
    importedBy: "entity-db-import-collections",
  },
};
